import { getConfig, isConfigSet } from './AppConfig';
export const getOauthClientId = (forceOauthPrefix) => {
    var _a;
    const customClientId = (_a = getConfig()) === null || _a === void 0 ? void 0 : _a.customClientId;
    if (customClientId) {
        return customClientId;
    }
    const { hostname } = window.location;
    const end = hostname.indexOf('.');
    let name = hostname.substring(0, end);
    if (end === -1) {
        name = hostname;
    }
    let env = 'production';
    if (isConfigSet()) {
        const config = getConfig();
        env = config.environment;
    }
    if (forceOauthPrefix && !name.includes('central')) {
        return `central-${name}-${env}`;
    }
    const gcpEnvMap = {
        development: '.dev',
        integration: '.int',
        stage: '.stg',
    };
    const gcpDomainTemplate = (appList) => `^(${appList.join('|')})[1-9]*${gcpEnvMap[env]}\\.seequent\\.com`;
    const gcpIMSApps = [
        'evo',
        'blocksync',
        'greenwich',
        'developer',
        'simval',
        'cpt2bh',
        'driver',
        'obsidian',
        'evonext',
    ];
    const gcpIMSHostPattern = new RegExp(gcpDomainTemplate(gcpIMSApps), 'i');
    if (gcpIMSHostPattern.test(hostname) || name === 'obsidian') {
        name = 'evo';
    }
    const gcpSQIDApps = ['central'];
    const gcpSQIDHostPattern = new RegExp(gcpDomainTemplate(gcpSQIDApps), 'i');
    if (gcpSQIDHostPattern.test(hostname)) {
        return `${name}-${env}-gcp`;
    }
    return `${name}-${env}`;
};
//# sourceMappingURL=getOauthClientId.js.map